import { getPreviousElement, focusAsync } from '@fluentui/react';
import { FocusWorker } from './FocusWorker';

export class LastElementFocusWorker extends FocusWorker {
    protected override scrollToElementCore(itemCount: number): void {
        this._list.current?.scrollToIndex(itemCount - 1);
    }

    protected override focusElement(): void {
        const rootElement = this._root.current;
        if (!rootElement) {
            return;
        }
        const lastChild = rootElement.lastElementChild as HTMLElement | null;
        const lastFocusableElement = getPreviousElement(rootElement, lastChild, true, true, true);
        focusAsync(lastFocusableElement);
    }
}
